var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-image',{staticClass:"g-pointer",style:({ width: _vm.width, height: _vm.height }),attrs:{"src":_vm.image,"fit":"scale-down"},on:{"click":_vm.toHome}})}
var staticRenderFns = []

export { render, staticRenderFns }